import { styled } from '@mui/material/styles'
import { Box, Typography } from '@mui/material'

export const HeaderWrapper = styled(Box)(`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 20px;
  position:relative;
  z-index:1;
`)

export const InfoWrapper = styled(Box)(({ theme }) => (`
  display: flex;
  align-items: center;
  & button {
    border-left:1px ${theme.components.LayoutHeader.styleOverrides.borderColor} solid;
    padding:20px;
    border-radius:0;
    height:72px;
  }
`))

export const UserName = styled(Typography)(`
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 14px;
  margin-right:20px;
`)
